/* src/app/modules/employees/bajas/bajas.component.css */
:host {
  --bj-brand: #e3fd64;
  --bj-brand-d: #4d7a00;
  --bj-text: #1a1d23;
  --bj-muted: #6b7280;
  --bj-border: #e5e7eb;
  --bj-surface: #ffffff;
  --bj-radius: 10px;
  --bj-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.bj-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.bj-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.bj-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.bj-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.bj-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.bj-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--bj-text);
  line-height: 1.2;
}
.bj-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--bj-muted);
}
.bj-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.bj-btn-primary {
  background-color: var(--bj-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.bj-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--bj-muted) !important;
}
.bj-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.bj-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.bj-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--bj-brand);
}
.bj-loading__dots {
  display: flex;
  gap: 8px;
}
.bj-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--bj-brand);
  opacity: 0.3;
  animation: bj-pulse 1.2s ease-in-out infinite;
}
.bj-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.bj-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.bj-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--bj-muted);
}
@keyframes bj-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.bj-download-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #e8f4fd;
  border: 1px solid #bfdbfe;
  color: #1d4ed8;
  font-size: 13.5px;
  font-weight: 500;
}
.bj-download-banner__icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.bj-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bj-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bj-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.bj-pill {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.bj-pill--active {
  background: #dc2626;
}
.bj-pill--hist {
  background: var(--bj-brand);
}
.bj-section__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--bj-text);
}
.bj-section__emp {
  font-weight: 400;
  color: var(--bj-muted);
}
.bj-card {
  background: var(--bj-surface);
  border-radius: var(--bj-radius);
  box-shadow: var(--bj-shadow);
  border: 1px solid var(--bj-border);
  overflow: hidden;
}
.bj-table {
  width: 100%;
}
.bj-table th.mat-mdc-header-cell {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--bj-muted);
  background: #f9fafb;
  border-bottom: 1px solid var(--bj-border);
  padding: 12px 16px;
}
.bj-table td.mat-mdc-cell {
  padding: 14px 16px;
  font-size: 13.5px;
  color: var(--bj-text);
  border-bottom: 1px solid var(--bj-border);
  vertical-align: middle;
}
.bj-row:last-child td.mat-mdc-cell {
  border-bottom: none;
}
.bj-row:hover td.mat-mdc-cell {
  background: #fafafa;
}
.bj-cell-employee {
  display: flex;
  align-items: center;
  gap: 10px;
}
.bj-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(227, 253, 100, 0.15);
  color: var(--bj-brand-d);
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  text-transform: uppercase;
}
.bj-date {
  font-size: 13px;
  color: var(--bj-muted);
  font-variant-numeric: tabular-nums;
}
.bj-motivo {
  font-size: 13px;
  color: var(--bj-text);
}
.bj-col-actions {
  width: 52px;
  text-align: right !important;
  padding-right: 12px !important;
}
.bj-menu-trigger {
  opacity: 0;
  transition: opacity 0.15s;
}
.bj-row:hover .bj-menu-trigger {
  opacity: 1;
}
.bj-filter-card {
  background: var(--bj-surface);
  border: 1px solid var(--bj-border);
  border-radius: var(--bj-radius);
  box-shadow: var(--bj-shadow);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.bj-filter-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--bj-text);
}
.bj-filter-card__icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--bj-brand);
}
.bj-filter-form {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.bj-filter-field {
  flex: 1;
  min-width: 220px;
}
.bj-filter-actions {
  display: flex;
  gap: 10px;
  padding-top: 4px;
  flex-shrink: 0;
}
.bj-action-danger,
.bj-action-danger mat-icon {
  color: #dc2626 !important;
}
.bj-action-danger:hover {
  background: rgba(220, 38, 38, 0.05) !important;
}
/*# sourceMappingURL=bajas.component.css.map */
